/**
 * Created by dreamc_t on 2017/2/14.
 */
let Core = require('f.component.video.pc');

let utils = require('f.component.util.pc');

let tabline = require('../tabline');

let tmpl = require('./main.ejs');

let defaultConf = {
    swfUrl: '//vxml.ifengimg.com/swf/ifengLivePlayer_v5.0.81.swf',
    containerId: '',
    width: 600,
    height: 455
};

let defaultParamConf = {
    allowFullScreen: 'true',
    wmode: 'transparent',
    allowScriptAccess: 'always'
};

let defaultVarConf = {
    ChannelID: '',
    RealStreamUrl: '',
    from: utils.getFrom(),
    ADPlay: true,
    adcpid: 1210,
    AutoPlay: true,
    uid: utils.getCookie('userid'),
    sid: utils.getCookie('sid'),
    locid: utils.getCookie('ilocid'),
    subject: 'live',
    pageurl: window.location.href,
    PlayerName: 'vLivePlayer',
    color: '0xC2C2C2',
    picUrl: 'http://vimg.ifeng.com/live/images/click.jpg',
    AutoP2P: false,
    picP2PUrl: 'http://vimg.ifeng.com/live/images/clickp2p.jpg',
    picP2PLink: '//v.ifeng.com/live/phlive.shtml',
    DisableEPG: false,
    columnName: '',
    danmuSpeed: 100,
    danmu: false,
    danmuInterval: 3,
    isVR: false,
    danmuBar: false,
    subject: ''
};

function formatOptions(videoData) {
    let optionsData = {
        conf: utils.containParams(defaultConf, videoData),
        varConf: utils.containParams(defaultVarConf, videoData),
        paramConf: utils.containParams(defaultParamConf, videoData),
        pauseCallback: function() {
            alert('pause');
        },
        autoPlay: true,
        listId: videoData.listId
    };

    return optionsData;
}

let Video = function(options) {
    this.init(options);
};

let currentVideo = null;

Video.current = currentVideo;

Video.prototype = {
    init: function(options) {
        this.list = options.list;
        this.videoOptions = [];
        // this.videoList = [];//视频列表
        // console.log(options);
        for (let i = 0; i < options.list.length; i++) {
            this.list[i].controls = false;
            this.list[i].m3u8Url = this.list[i].m3u8;
            this.list[i].width = options.livewidth;
            this.list[i].height = options.liveheight;
            this.list[i].picUrl = this.list[i].poster || '//y0.ifengimg.com/ffeefe4ba8f67e3e/2015/2/livepic-nobtn.png';
            this.list[i].swfUrl = '//p1.ifengimg.com/a/2019/0313/livePlayer.swf';
            this.list[i].RealStreamUrl = this.list[i].rtmp;
            this.list[i].danmu = options.danmu;
            this.list[i].ChannelID = this.list[i].channelId;
            this.list[i].listId = i;
            this.videoOptions.push(formatOptions(this.list[i]));
        }

        // console.log(this.videoOptions);
        this.el = $(tmpl());
        // this.danmuBox = this.el.find('.danmubox');
        this.initDom(options);
        this.bindDomEvent();
    },

    initDom: function() {
        let tablineHtml = new tabline({ list: this.list });
        tablineHtml.renderTo(this.el);
        currentVideo = new Core(this.videoOptions[0], true);
        currentVideo.renderTo($(this.el).find('.c-video__embed'));
        Video.current = currentVideo;
    },

    bindDomEvent: function() {
        let _self = this;

        this.el.on('click', '[data-lineid]', function() {
            let lineid = $(this).data('lineid');
            if (!$(this).hasClass('clicked')) {
                return false;
            } else {
                if (Video.current != null) {
                    currentVideo.destroy();
                    currentVideo = null;
                }
                currentVideo = new Core(_self.videoOptions[lineid], true);
                Video.current = currentVideo;
                currentVideo.renderTo(_self.el.find('.c-video__embed'));
            }
        });

        // this.el.on('click', '.danmubox',function () {
        //     var $flash;
        //     var lineId = $('.c-videoList .clicked').data('lineid');
        //         $flash = document.getElementById('js_streamVideo' + lineId);
        //     if($('.danmu-img').hasClass('on')){
        //         $('.danmu-img').addClass('off');
        //         $('.danmu-img').removeClass('on');

        //         $flash.closeDanmu();
        //        _self.changgeDanmu(false);

        //     }else {
        //         $('.danmu-img').removeClass('off');
        //         $('.danmu-img').addClass('on');
        //         $flash.openDanmu();
        //         _self.changgeDanmu(true);
        //     }
        // });
    },

    changgeDanmu: function(isdanmu) {
        this.videoOptions.map(function(item) {
            item.varConf.danmu = isdanmu;
        });
    },

    showBack: function(content) {
        Video.current.danmuSend(content);
    },

    renderTo: function(parentNode) {
        parentNode.append(this.el);
    }
};

module.exports = Video;



// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.videohead.pc/app/modules/video/stream.js